import {useCallback} from 'react';
import {ModalManagerRefObject} from '@esgillc/ui-kit/modal';

export function useAlertClose(alertRef: ModalManagerRefObject, cb?: VoidFunction) {
	return useCallback(() => alertRef.current?.close(cb), [alertRef, cb]);
}
